import { Component, inject } from '@angular/core';
import { AbstractSelectionService } from 'gung-list';
import { EdiPricatListConfigService } from '../../../services/edi-pricat-list-config/edi-pricat-list-config.service';
import { ProductSelectionService } from '../../../services/product-selection-service/product-selection.service';

@Component({
  selector: 'lib-edi-list-pricats',
  template: `<lib-edi-list-wrapper
    [configService]="configService"
    title="EDI - PRICAT">
  </lib-edi-list-wrapper>`,
  styleUrls: ['./edi-list-pricats.component.css'],
  providers: [
    {
      provide: AbstractSelectionService,
      useClass: ProductSelectionService
    }
  ],
  standalone: false
})
export class EdiListPricatsComponent {
  public configService = inject(EdiPricatListConfigService);
}
